import React from 'react';
import ReactImageFallback from 'react-image-fallback';
import PropTypes from 'prop-types';
import { FALLBACK_ICON } from '../image';
import MediaRender from './mediaRender';
import { capitalizeEveryWord } from '../common';
import RenderSharedSocialIcons from './RenderSharedSocialIcons';
import { BETA_POST_ENUM } from '../constants';

const RenderRequestPopup = (props) => {
  const {
    displayUser, displayTimeAgo, mediaPopup, renderMedia, sharedPost,
  } = props;

  return (
    <>
      <div className="request-user">
        <span>
          <ReactImageFallback
            src={displayUser && displayUser.user.artistImage}
            fallbackImage={FALLBACK_ICON}
            className="image-cover"
            alt="User"
          />
        </span>
        <div className="request-user-detail">
          <h3>{displayUser && capitalizeEveryWord(displayUser.user.name)}</h3>
          <p>{displayTimeAgo(displayUser && displayUser.status, displayUser && displayUser.timeLine)}</p>
        </div>
        {
          displayUser && (displayUser.status === BETA_POST_ENUM.PUBLISHED || displayUser.status === BETA_POST_ENUM.COMPLETED)
        && (
        <div className="social-icons">
          {RenderSharedSocialIcons(sharedPost).map((ele) => ele)}
        </div>
        )
        }
      </div>
      <div className="modal-request-account-image-wrap">
        {displayUser && MediaRender(displayUser.media).map((obj) => (
          <div
            key={obj._id}
            className="analytics-card-media"
            onClick={() => mediaPopup(obj && obj.file)}
          >
            {renderMedia(obj.media, obj.file)}
          </div>
        ))}
      </div>
      <p className="beta-post-text">
        {displayUser && displayUser.betaPostInfo}
      </p>
    </>
  );
};

RenderRequestPopup.propTypes = {
  displayUser: PropTypes.object.isRequired,
  displayTimeAgo: PropTypes.func.isRequired,
  mediaPopup: PropTypes.func.isRequired,
  renderMedia: PropTypes.func.isRequired,
  sharedPost: PropTypes.object.isRequired,
};

export default RenderRequestPopup;
